const SHOW_BROWSER_LIVE_PREVIEW_KEY = 'designstudio.showBrowserLivePreview';

/** Default: show the chat browser panel when a live screenshot is available. */
const DEFAULT_SHOW = true;

let memoryPreference: boolean | undefined;

type LocalStorageLike = {
  readonly getItem: (key: string) => string | null;
  readonly setItem: (key: string, value: string) => void;
  readonly removeItem: (key: string) => void;
};

function readStorage(): LocalStorageLike | undefined {
  if (typeof globalThis === 'undefined') {
    return undefined;
  }
  try {
    const storage = (globalThis as { readonly localStorage?: LocalStorageLike }).localStorage;
    if (storage === undefined) {
      return undefined;
    }
    const probeKey = `${SHOW_BROWSER_LIVE_PREVIEW_KEY}.probe`;
    storage.setItem(probeKey, '1');
    storage.removeItem(probeKey);
    return storage;
  } catch {
    return undefined;
  }
}

/** Whether the agent browser live panel is visible in the chat (default: shown). */
export function readShowBrowserLivePreview(): boolean {
  const storage = readStorage();
  if (storage !== undefined) {
    const value = storage.getItem(SHOW_BROWSER_LIVE_PREVIEW_KEY);
    if (value === '0') {
      return false;
    }
    if (value === '1') {
      return true;
    }
    return DEFAULT_SHOW;
  }
  if (memoryPreference !== undefined) {
    return memoryPreference;
  }
  return DEFAULT_SHOW;
}

export function writeShowBrowserLivePreview(enabled: boolean): void {
  const storage = readStorage();
  if (storage !== undefined) {
    storage.setItem(SHOW_BROWSER_LIVE_PREVIEW_KEY, enabled ? '1' : '0');
  }
  memoryPreference = enabled;
}
